import logo from './logo.svg';
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Dashboard from './Dashboard';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import UserList from './UserList';
import Payments from './Payments';
import Settings from './Settings';
import ProductsList from './products/ProductsList';
import EditProducts, { EditProductsc } from './products/EditProducts';
import AddProducts from './products/AddProducts';
import OrderList, { OrderListc } from './OrderList';
import OrderDescription, { OrderDescriptionc } from './OrderDescription';
import Login from './Login';
import Errror from './Errror';


function App() {
  let is_login = sessionStorage.getItem('is_login')
  return (
    <Box sx={{backgroundColor:'#f8f9ff'}}>
    <React.StrictMode>
    <RouterProvider router={createBrowserRouter([
      

      {
        path:"/",
        element:<Login/>,
        },
    {
    path:"/dashboard",
    element: is_login=='true' ?<Dashboard/> : <Errror/>,
    },
    {
      path:"/user",
      element: is_login=='true' ?<UserList/>: <Errror/>,
      },

      {
        path:"/transaction",
        element:is_login=='true' ?<Payments/> : <Errror/>
      },
      {
        path:"/settings",
        element:is_login=='true' ?<Settings/>: <Errror/>
      },
   /// project section
   {
    path:"/productsList",
    element:is_login=='true' ?<ProductsList/>: <Errror/>
  },
  {
    path:"/editProducts/:id",
    element:is_login=='true' ?<EditProductsc/>: <Errror/>
  },
  {
    path:"/addProducts",
    element:is_login=='true' ?<AddProducts/>: <Errror/>
  },


  //// order section

{
  path:'/orderList',
  element:is_login=='true' ?<OrderListc/>: <Errror/>
},

{
  path:'/orderDescription/:id',
  element:is_login=='true' ?<OrderDescriptionc/>: <Errror/>
}






])} />

</React.StrictMode>
</Box>

  );
}

export default App;
